import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import APH from './RegulationResults';

const RegulationResultsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Regulation Results',
            }}
        >
            <APH />
        </ServicesChartsDataProvider>
    );
};

export default RegulationResultsWrapper;
